import { Button, Modal, Table } from "react-bootstrap";
import getShipmentStatus from "../../../../function/getShipmentStatus";
import "../../../../pages/digikalaSeller/components/digikalaOrders/OrderGetPriceModal.css";

export default function OrderDetailModal({ state, onClose }) {
  const order = state.order;
  if (!order) {
    return;
  }

  const technicalService =
    order.realPayable -
    order.collector -
    order.Insurance -
    order.Packaging -
    order.Freight -
    order.freight_dispute -
    order.printFactor -
    order.hasNotifRequest -
    order.serviceInPlace -
    order.TAX;

  return (
    <Modal
      show={state.showModal}
      centered
      direction="rtl"
      className="modal-lg modal-nobg"
      size="xl"
    >
      <Modal.Body>
        <h4 className="w-100 pb-2">جزئیات مالی مرسوله</h4>

        <div className="dgk">
          <div className="dgk-details">
            <div className="dgk-details-grid">
              <div className="dgk-detail-card">
                <div className="dgk-detail-title">مبلغ سرویس دهنده</div>
                <div style={{ fontWeight: 700 }}>
                  {(order.Freight + order.freight_dispute).toLocaleString()}
                  <span> ریال</span>
                </div>
              </div>

              <div className="dgk-detail-card">
                <div className="dgk-detail-title">جمع آوری</div>
                <div style={{ fontWeight: 700 }}>
                  {order.collector.toLocaleString()} ریال
                </div>
              </div>
              <div className="dgk-detail-card">
                <div className="dgk-detail-title">بیمه</div>
                <div style={{ fontWeight: 700 }}>
                  {order.Insurance.toLocaleString()} ریال
                </div>
              </div>
              <div className="dgk-detail-card">
                <div className="dgk-detail-title">بسته بندی</div>
                <div style={{ fontWeight: 700 }}>
                  {order.Packaging.toLocaleString()} ریال
                </div>
              </div>

              <div className="dgk-detail-card">
                <div className="dgk-detail-title">خدمات در محل</div>
                <div style={{ fontWeight: 700 }}>
                  {order.serviceInPlace.toLocaleString()} ریال
                </div>
              </div>

              <div className="dgk-detail-card">
                <div className="dgk-detail-title">پرینت فاکتور</div>
                <div style={{ fontWeight: 700 }}>
                  {order.printFactor.toLocaleString()} ریال
                </div>
              </div>
              <div className="dgk-detail-card">
                <div className="dgk-detail-title">پیامک</div>
                <div style={{ fontWeight: 700 }}>
                  {order.hasNotifRequest.toLocaleString()} ریال
                </div>
              </div>
              <div className="dgk-detail-card">
                <div className="dgk-detail-title">خدمات فنی و مهندسی</div>
                <div style={{ fontWeight: 700 }}>
                  {technicalService.toLocaleString()} ریال
                </div>
              </div>
              <div className="dgk-detail-card">
                <div className="dgk-detail-title">مالیات</div>
                <div style={{ fontWeight: 700 }}>
                  {order.TAX.toLocaleString()} ریال
                </div>
              </div>
              <div className="dgk-detail-card">
                <div className="dgk-detail-title">مبلغ COD</div>
                <div style={{ fontWeight: 700 }}>
                  {order.amountCOD.toLocaleString()} ریال
                </div>
              </div>
            </div>
          </div>
        </div>

        <h4 className="text-center m-0 py-3">
          <small>مبلغ کل: </small>
          <span>{(order.realPayable + order.amountCOD).toLocaleString()}</span>
          <small> ریال</small>
        </h4>

        <h5 className="w-100 pb-2 pt-5">لیست پارت های های فاکتور</h5>

        <div className="w-100 overflow-x-auto px-1">
          <Table striped bordered>
            <thead>
              <tr>
                <th>#</th>
                <th>شماره پارت</th>
                <th>ابعاد</th>
                <th>نوع بسته بندی</th>
                <th>محتوی</th>
                <th>ارزش کالا</th>
                <th>وزن</th>
                <th>وضعیت</th>
                <th>بیمه کالا</th>
              </tr>
            </thead>
            <tbody>
              {state.myParts.map((part, index) => (
                <tr key={index} className="align-middle">
                  <td>{index + 1}</td>
                  <td>{part.partnumber}</td>
                  <td style={{ minWidth: 120 }}>
                    <span>{part.width}</span>
                    <span> × </span>
                    <span>{part.height}</span>
                    <span> × </span>
                    <span>{part.length}</span>
                  </td>
                  <td>{part.typeId}</td>

                  <td>
                    {part.content?.length > 0 ? (
                      part.content.map((item, index) => (
                        <tr key={index}>
                          <td
                            className="border border-2"
                            style={{ minWidth: 30 }}
                          >
                            {item.total}
                          </td>
                          <td className="border border-2 w-100">
                            {item.title}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <span>{part.shipment}</span>
                    )}
                  </td>

                  <td>{part.value?.toLocaleString()}</td>
                  <td>{part.weight}</td>
                  <td>{getShipmentStatus(part.status)}</td>
                  <td>{part.cost?.toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Modal.Body>

      <Modal.Footer className="d-flex align-item-center justify-content-center">
        <Button className="btn-cancel-style" onClick={onClose}>
          فهمیدم
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
